<template>
  <modal name="changePasswordPopup" :width="500" :height="460" :clickToClose="false"
      @before-open="beforeOpen"
      @opened="opened">
    <DxValidationGroup ref="validationGroup">
    <div id="div_changePasswordPopup" class="popup">
      <div class="pop_tit">
        <span>비밀번호 변경</span>
        <a href="javascript:void(0);" title="close" class="pop_close" @click="close">close</a>
      </div>
      <div class="pop_con_wrap">
        <div class="pop_con pw_change">
          <div class="row">
            <span><i class="xi-user-o"></i></span>
            <DxTextBox name="아이디" placeholder="아이디" v-model="form.loginId" :disabled="true">
              <DxValidator>
                <DxRequiredRule message="아이디"/>
              </DxValidator>
            </DxTextBox>
          </div>
          <div class="row">
            <span><i class="xi-lock-o"></i></span>
            <DxTextBox name="현재 비밀번호" :placeholder="formatMessage('nowPassword')" v-model="form.curentPassword" mode="password">
              <DxValidator>
                <DxRequiredRule :message="formatMessage('pwdMsg')"/>
              </DxValidator>
            </DxTextBox>
          </div>
          <div class="row">
            <span><i class="xi-lock-o"></i></span>
            <DxTextBox name="변경 비밀번호" :placeholder="formatMessage('password')" v-model="form.updatePassword" mode="password">
              <DxValidator>
                <DxPatternRule
                  :pattern="pwdPattern"
                  :message="formatMessage('pwdPattern')"
                />
                <DxStringLengthRule
                  :min="8"
                  :max="20"
                  :message="formatMessage('stringLen')"
                />
                <DxRequiredRule :message="formatMessage('pwdMsg')"/>
              </DxValidator>
            </DxTextBox>
          </div>
          <div class="row">
            <span><i class="xi-lock-o"></i></span>
            <DxTextBox name="확인 비밀번호" :placeholder="formatMessage('confirmationPassword')" v-model="form.confirmPassword" mode="password">
              <DxValidator>
                <DxRequiredRule :message="formatMessage('rePwdMsg')"/>
                <DxCompareRule
                  :comparison-target="passwordComparison"
                  :message="formatMessage('checkRePwdMsg')"
                />
              </DxValidator>
            </DxTextBox>
          </div>
        </div>
      </div>
      <div class="pop_footer_wrap">
        <div class="pop_btn_area">
          <button class="btn_type_01 save" @click="updatePassword">확인</button>
          <button class="btn_type_01 delete" @click="close">닫기</button>
        </div>
      </div>
    </div>
    </DxValidationGroup>
  </modal>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'
import TimeCounter from '@/components/TimeCounter'
import Utils from '@/modules/utils'
import {locale, loadMessages, formatMessage } from 'devextreme/localization'
import DxTextBox from 'devextreme-vue/text-box'
import DxValidationGroup from 'devextreme-vue/validation-group'
import {
  DxValidator,
  DxRequiredRule,
  DxCompareRule,
  DxEmailRule,
  DxPatternRule,
  DxStringLengthRule,
  DxRangeRule
} from 'devextreme-vue/validator'

export default {
  name: 'changePasswordPopup',
  components: { 
    TimeCounter,
    DxValidator,
    DxRequiredRule,
    DxCompareRule,
    DxEmailRule,
    DxPatternRule,
    DxStringLengthRule,
    DxRangeRule,
    DxValidationGroup,
    DxTextBox
  },
  data: () => ({
    form: {
      loginId: '',
      curentPassword: '',
      updatePassword: '',
      confirmPassword: ''
    },
    authNumberTime: 180,
    pwdPattern: /^.*(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*#?&]).*$/
  }),  
  methods: {
    formatMessage:formatMessage,
    beforeOpen(e) {
      console.log(e.params.userId)
      this.form.loginId = e.params.userId;
    },
    opened(e) {  

			var popLeft = (($(window).width() - $('#div_changePasswordPopup').outerWidth()) / 2);
			var popTop = (($(window).height() - $('#div_changePasswordPopup').outerHeight()) / 2 );
			if(popLeft < 0) popLeft = 0;
			if(popTop < 0) popTop = 0;
			$('#popupMask').fadeIn();
			$('#div_changePasswordPopup').css({"left":popLeft, "top":popTop}).fadeIn().addClass('on');

			$(".mscroll").mCustomScrollbar( {
				theme: "dark-thick",
				scrollInertia: 600
			});

    },
    updatePassword () {
      if(this.$refs['validationGroup'].instance.validate().isValid){

        // 비밀번호 변경
        Vue.httpClient
        .post('/app/login/password/update', this.form)
        .then( async (response) => {
          if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
            await Vue.Alert.alert('비밀번호 변경에 성공하였습니다.')
            this.closed()
            this.$modal.hide('changePasswordPopup')
          } 
        })             

      };
    }, 
    close() {
      this.closed()
      this.$modal.hide('changePasswordPopup');
    },
    closed(){
      $('#pop_up').fadeOut().removeClass('on');
      $('#popupMask').fadeOut();
    },
    passwordComparison(){
      return this.form.updatePassword
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/common/ChangePasswordPopup.vue